// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomQuoteModel, QuotesCollectionModel } from "@adl/App/Services/CustomQuotesService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";


export interface xMyCustomQuotesType {
    isLoading: boolean;
    quotes: CustomQuoteModel[];
    pagination: PaginationModel;
    getCustomQuotesParameter: { page: number; pageSize: number; sort: string; search: string };
}

const initialState: xMyCustomQuotesType = {
    isLoading: false,
    quotes: [],
    pagination: {} as any,
    getCustomQuotesParameter: { page: 1, pageSize: 8, sort: "4", search: "" },
};

const reducer = {
    "Pages/xMyCustomQuotes/BeginLoadingQuotes": (draft: Draft<xMyCustomQuotesType>) => {
        draft.isLoading = true;
    },
    "Pages/xMyCustomQuotes/CompleteLoadingQuotes": (
        draft: Draft<xMyCustomQuotesType>,
        actions: { quotes?: QuotesCollectionModel },
    ) => {
        draft.isLoading = false;
        if (actions.quotes) {
            draft.quotes = actions.quotes.customQuoteCollection;
            draft.pagination = actions.quotes.pagination;
        }
    },
    "Pages/xMyCustomQuotes/UpdateLoadParameter": (
        draft: Draft<xMyCustomQuotesType>,
        actions: { parameter: { page: number; pageSize: number; sort: string; search: string } },
    ) => {
        draft.getCustomQuotesParameter = { ...draft.getCustomQuotesParameter, ...actions.parameter };

        for (const key in draft.getCustomQuotesParameter) {
            const value = (<any>draft.getCustomQuotesParameter)[key];

            // remove empty parameters
            if (value === "" || value === undefined) {
                delete (<any>draft.getCustomQuotesParameter)[key];
            }
        }

        for (const key in actions.parameter) {
            // go back to page 1 if any other parameters changed
            if (draft.getCustomQuotesParameter.page && draft.getCustomQuotesParameter.page > 1 && key !== "page") {
                draft.getCustomQuotesParameter.page = 1;
            }
        }
    },
};

const xMyCustomQuotes = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).xMyCustomQuotes = xMyCustomQuotes;

export type xMyCustomQuotesState = {
    xMyCustomQuotes: xMyCustomQuotesType;
} & ApplicationState;
